import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.25151 7L3 8.0617L10 14.5L17 8.0617L15.7485 7L10 12.5L4.25151 7Z", fill: "#90A0B7" }));
export default SvgChevronDown;
